import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>(theme => ({
  menuItem: {
    position: 'relative',
    padding: '7px 15px',
    transition: '.2s',
    background: 'rgba(255,255,255,0)',
    textDecoration: 'none',
    '&:hover': {
      background: 'rgba(255,255,255,.3)',
      transition: '.2s',
      cursor: 'pointer'
    }
  },
  disabled: {
    '&:hover': {
      background: 'none',
      cursor: 'not-allowed'
    }
  },
  menuItemSelected: {
    background: 'rgba(255,255,255,.3)'
  },
  menuItemText: {
    color: 'white',
    fontSize: 14
  },
  menuItemTextDisabled: {
    color: '#8D60C6'
  },
  icon: {
    top: -10,
    left: -10,
    position: 'absolute',
    color: theme.palette.common.yellow
  }
}))
